import { render, staticRenderFns } from "./ServiceCategoryTabMoveButton.vue?vue&type=template&id=2a5f2a9a&scoped=true&"
import script from "./ServiceCategoryTabMoveButton.vue?vue&type=script&lang=ts&"
export * from "./ServiceCategoryTabMoveButton.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceCategoryTabMoveButton.vue?vue&type=style&index=0&id=2a5f2a9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f2a9a",
  null
  
)

export default component.exports